import { useEffect, useState } from 'react';

const CHECK_INTERVAL = 5 * 60 * 1000;

const useVersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    if (process.env.REACT_APP_ENV !== 'production') return;

    let currentVersion = null;

    const getCurrentVersion = async () => {
      try {
        const r = await fetch('/version.json', { cache: 'no-cache' });
        const d = await r.json();
        currentVersion = d.version;
      } catch {}
    };

    const checkForUpdates = async () => {
      if (!currentVersion) return;
      try {
        const r = await fetch('/version.json', { cache: 'no-cache' });
        const d = await r.json();
        if (d.version !== currentVersion) setUpdateAvailable(true);
      } catch {}
    };

    getCurrentVersion();
    const interval = setInterval(checkForUpdates, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return updateAvailable;
};

export default useVersionCheck;
